import Logo from "@/components/creations/logo";
import { ArrowLeft, Menu, X } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import Link from "next/link";
import { useState } from "react";
import { cn } from "@/lib/utils";
import { LinksContainer } from "./links-container";
import { glassCardVariants } from "../glass-card";

export default function NavBar({
  NavLinks,
  isMobile = false,
}: {
  NavLinks: any[];
  isMobile?: boolean;
}) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  return (
    <div className="p-1 md:px-4 relative">
      {isMobile ? (
        <DropdownMenu open={isMobileOpen} onOpenChange={setIsMobileOpen}>
          <DropdownMenuTrigger asChild>
            <Menu className="h-6" />
          </DropdownMenuTrigger>
          <DropdownMenuContent
            align="end"
            className={glassCardVariants({ className: "border-none mt-4 p-4" })}
          >
            <div className="flex gap-2 items-center mb-4">
              <span
                onClick={() => setIsMobileOpen(false)}
                className="p-1 hover:text-primary transition-colors border-r border-b hover:border-r-primary hover:border-b-primary rounded-br-lg"
              >
                <X className="size-5" />
              </span>
              <span className="font-semibold">Menu</span>
            </div>
            <LinksContainer links={NavLinks} />
          </DropdownMenuContent>
        </DropdownMenu>
      ) : (
        <div
          className={cn(
            "transition-all duration-300",
            isCollapsed ? "w-16" : "w-full",
          )}
        >
          <button
            onClick={() => setIsCollapsed(!isCollapsed)}
            className="absolute top-0 right-0 -translate-x-0.5 -translate-y-0.5 border-l border-b hover:border-l-primary hover:border-b-primary rounded-bl-lg p-2 w-min cursor-pointer transition-colors z-10 bg-transparent"
            title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            <ArrowLeft
              className={cn(
                "size-6 hover:text-primary transition-all duration-300",
                isCollapsed && "rotate-180",
              )}
            />
          </button>

          <div className="flex flex-col gap-4">
            {!isCollapsed && (
              <Link href="/" className="mr-12">
                <Logo />
              </Link>
            )}

            <LinksContainer links={NavLinks} isCollapsed={isCollapsed} />
          </div>
        </div>
      )}
    </div>
  );
}
